import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import VueAnalytics from "vue-analytics";
import camelCase from "lodash/camelCase";
import upperFirst from "lodash/upperFirst";
import Meta from "vue-meta";
import VueScrollTo from "vue-scrollto";
import VueAnimate from 'vue-animate-scroll';
import VueSession from 'vue-session';

var SocialSharing = require('vue-social-sharing');


const requireModal = require.context(
  './modals',
  false,
  /[A-Z]\w+\.(vue|js)$/
);

requireModal.keys().forEach(fileName => {
  const componentConfig = requireModal(fileName);

  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  );

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  );
});

Vue.use(SocialSharing);
Vue.use(VueSession)
Vue.use(Meta);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(require("vue-moment"));
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 });

Vue.use(VueAnalytics, {
  id: 'UA-11111', /* enter google analytics id here */
	router
});
Vue.use(VueAnimate);

Vue.config.productionTip = false;

new Vue({
  router,
  BootstrapVue,
  store,
  render: h => h(App)
}).$mount("#app");
